import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  connectedCallback() {
    super.connectedCallback();
    this.#lockCoffretLine();
  }

  #lockCoffretLine() {
    const row = this.closest('[data-key]');
    if (!row) return;

    const isCoffret = [...row.querySelectorAll('.cart-items__properties')].some((property) =>
      property.textContent.includes('Coffret personnalisé')
    );

    if (!isCoffret) return;

    this.setAttribute('data-coffret-locked', '');
    this.querySelectorAll('button, input').forEach((control) => {
      control.disabled = true;
      control.setAttribute('aria-disabled', 'true');
    });

    const removeButton = row.querySelector('.cart-items__remove');
    if (removeButton) {
      removeButton.hidden = true;
      removeButton.disabled = true;
      removeButton.setAttribute('aria-hidden', 'true');
    }

    row.classList.add('mdm-coffret-locked');
  }

  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }

  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    if (this.hasAttribute('data-coffret-locked')) {
      minusButton.disabled = true;
      plusButton.disabled = true;
      return;
    }

    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
